<template lang="pug">
label.input-text
  .input-text__label State
  input.input-text__input(
    type="text"
    placeholder=""
    v-model.trim="value"
    @keyup="changeFieldValue()"
  )
</template>

<script>
import { mapMutations, mapGetters } from 'vuex'

export default {
  name: 'FieldState',

  data () {
    return {
      value: ''
    }
  },

  computed: {
    ...mapGetters([
      'fieldState'
    ])
  },

  methods: {
    ...mapMutations([
      'changeField'
    ]),

    changeFieldValue () {
      this.changeField({
        name: 'fieldState',
        value: this.value
      })
    }
  },

  created() {
    this.value = this.fieldState
  }
}
</script>
